import { envSettings } from "core/EnvSettings";
import { useGetOne } from "react-admin";

import { useOrderServiceType } from "./useOrderServiceType";

export const useCanScanToCreatePallet = (record) => {
	const { isIncomingPlukk, isCrossDock } = useOrderServiceType(record);
	const isScanToCreateEligible =
		(isIncomingPlukk || isCrossDock) && envSettings.REACT_APP_FF_STORAGE_MODULE;
	const { data: customerCompany } = useGetOne("customer-companies", record.company_id, {
		enabled: isScanToCreateEligible && !!record.company_id,
	});
	return isScanToCreateEligible && !!customerCompany?.incoming_order_can_scan_to_create;
};
